import Button from "olive-react-myoneui/lib/Button";

export default function LearnerHeading(props) {
  const { className, svgIcon, title, itemCounter, children, headerActionBtn, headerActionBtnOnClick } = props;
  return (
    <div className={`learner-heading ${className || ''}`}>
      <div className="info-wrap">
        <div className="myk_learner-title">
          {svgIcon && <>{svgIcon}</>}
          {title && <h4>{title} {itemCounter && <span>{itemCounter}</span>}</h4>}
        </div>
        {/* {headerActionBtn && 
          <Button variant="outline" className="btn-sm d-flex align-items-center gap-2 bg-transparent" onClick={headerActionBtnOnClick}>
            {headerActionBtn}
          </Button>
        } */}
      </div>
      {children}
    </div>
  );
}
